const allKeys = [
  {
    value: 'AC',
  },
  {
    value: '+/-',
  },
  {
    value: '%',
  },
  {
    value: '÷',
    rightKey: true,
  },
  {
    value: '7',
  },
  {
    value: '8',
  },
  {
    value: '9',
  },
  {
    value: 'x',
    rightKey: true,
  },
  {
    value: '4',
  },
  {
    value: '5',
  },
  {
    value: '6',
  },
  {
    value: '-',
    rightKey: true,
  },
  {
    value: '1',
  },
  {
    value: '2',
  },
  {
    value: '3',
  },
  {
    value: '+',
    rightKey: true,
  },
  {
    value: '0',
    doubleWidth: true,
  },
  {
    value: '.',
  },
  {
    value: '=',
    rightKey: true,
  },
];

export default allKeys;
